import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { THEME } from '@/styles/theme';
import { bodySmall, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const PopoverAnchorContainer = styled.div``;

export const PopoverMenuWrapper = styled.div<{ $minWidth: string }>`
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid ${COLORS.grey[400]};
  background: ${COLORS.white};
  box-shadow: 0 4px 8px 0 rgb(0 6 38 / 20%);
  min-width: ${({ $minWidth }) => $minWidth ?? '220px'};
  max-width: 300px;
  z-index: ${THEME.modal.zIndex};
  overflow: hidden;
`;

export const PopoverMenuItemWrapper = styled.div`
  ${flex({ alignItems: 'center' })};
  column-gap: 10px;
  padding: 12px 16px;
  cursor: pointer;
  ${bodySmall};
  ${poppinsMediumFont};
  border-bottom: 1px solid ${COLORS.grey[350]};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${COLORS.grey[50]};
  }
`;
